import { useAuth as useAuthContext } from '../services/AuthContext';

export const useAuth = useAuthContext;
